import React, { useEffect, useRef, useState } from 'react';
import { Async as SearchInput } from 'react-select';
import * as api from '../../utils/apis';
import { debounce } from 'lodash';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';
import styles from '../../styles.module.scss';
import toastr from '../../utils/toastr';

const OrganizationSearch = () => {
  const {
    setSelectedOrgSearch,
    setSelectedOrgNode
  } = useVendorPointSolutionContext();

  const [searchData, setSearchData] = useState(null);
  const debouncedSearch = useRef(null);

  useEffect(() => {
    debouncedSearch.current = debounce(() => search(), 500);
    debouncedSearch.current();

    return () => debouncedSearch.current.cancel();
  }, [searchData]);


  const search = async () => {
    if (!searchData) {
      return;
    }

    const {orgName, setResult} = searchData;
    if (orgName.length < 2) {
      return;
    }

    const orgs = await api.fetchOrganizationsByName(orgName);

    if (orgs) {
      const result = orgs.map(org => ({
        value: org.organization_id,
        label: org.organization_nm
      }))

      setResult(result)
    }else{
      toastr.error('Something went wrong');
    }
  };

  const handleSearch = (orgName, setResult) => {
    setSearchData({
      orgName,
      setResult
    });
  };

  const handleSelectedOrg = org => {
    setSelectedOrgSearch({
      organization_id: org.value,
      organization_nm: org.label
    });
    setSelectedOrgNode(null);
  };

  const customStyles = {
    control: () => ({
      border: '1px solid #727069',
      borderRadius: '4px',
      display: 'flex',
      height: '30px',
      width: '300px'
    })
  };

  return (
    <div className={styles.orgSearchContainer} id='organization-search-form'>
      <label htmlFor="organization-search">Parent Organization</label>
      <SearchInput
        styles={customStyles}
        id='organization-search'
        loadOptions={handleSearch}
        onChange={handleSelectedOrg}
        placeholder='Search an organization'
      />
    </div>
  );
}

export default OrganizationSearch;
